/**
* Created by lobin on 2020/7/31.
*/
<template>
	<div class="role">
		<a-card :body-style="{padding: '24px 32px'}" :bordered="false">
			<a-button type="primary" class="editable-add-btn" @click="handleAdd">
				添加
			</a-button>
			<a-divider />
			<a-table
				:loading="loading"
				:columns="columns"
				:data-source="list"
				size="middle"
				:scroll="{y: 600 }"
			>
				<span slot="action" slot-scope="text, record">
          <a @click="modify(record)">修改</a>
					<a-divider type="vertical" />
					<a @click="modifyPermission(record._id, record.permissions)">授权</a>
        </span>
				<span slot="status" slot-scope="text">
					<a-tag color="#87d068" v-if="text">在用</a-tag>
					<a-tag color="#f50" v-else>禁用</a-tag>
        </span>
				<span slot="permissions" slot-scope="text">
					<a-tag color="#87d068" v-for="item in text" :key="item._id">{{ item.name }}</a-tag>
        </span>
			</a-table>
		</a-card>
		<a-modal
			:title="editType === 'add' ? '添加资源' : '编辑资源'"
			:visible="visible"
			:confirm-loading="submiting"
			@ok="handleOk"
			@cancel="handleCancel"
		>
			<a-form-model
				ref="ruleForm"
				:model="form"
				:rules="rules"
				:label-col="labelCol"
				:wrapper-col="wrapperCol"
			>
				<a-form-model-item label="权限名称" prop="name">
					<a-input v-model="form.name" placeholder="输入资源名称" />
				</a-form-model-item>
				<a-form-model-item label="权限别称" prop="alias">
					<a-input v-model="form.alias" placeholder="输入资源key" />
				</a-form-model-item>
				<a-form-model-item label="角色类型" prop="type">
					<a-radio-group v-model="form.type">
						<a-radio value="company">公司</a-radio>
						<a-radio value="admin">后台</a-radio>
					</a-radio-group>
				</a-form-model-item>
				<a-form-model-item label="是否可用" prop="status">
					<a-switch v-model="form.status" />
				</a-form-model-item>
			</a-form-model>
		</a-modal>
		<Permission ref="permission" />
	</div>
</template>

<script type="text/babel">
import {
  getRole,
  createRole,
  updateRole,
  getResource,
} from '@/api/settings';
import { mapGetters } from 'vuex';
import Permission from './permission.vue';

export default {
  components: { Permission },
  data() {
    return {
      id: '',
      form: {},
      search: {},
      list: [],
      loading: false,
      submiting: false,
      editType: 'add',
      visible: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
	    resource: [],
    };
  },
  created() {
    this.getList();
  },
  computed: {
    ...mapGetters(['methods']),
    columns() {
      return [
        {
          title: '#',
          dataIndex: 'index',
          customRender: (text, row, index) => index + 1,
          key: 'index',
          width: '50px',
        },
        {
          title: '名称',
          dataIndex: 'name',
          key: 'name',
        },
        {
          title: '别称',
          dataIndex: 'alias',
          width: 160,
          key: 'alias',
        },
        {
          title: '类型',
          dataIndex: 'type',
          key: 'type',
        },
	      // {
		    //   title: '权限',
		    //   dataIndex: 'permissions',
		    //   key: 'permissions',
	      //   scopedSlots: { customRender: 'permissions' },
	      // },
        {
          title: '状态',
          dataIndex: 'status',
          key: 'status',
          scopedSlots: { customRender: 'status' },
        },
        // {
        //   title: '创建时间',
        //   dataIndex: 'ctime',
        //   key: 'ctime',
        // },
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 200,
          scopedSlots: { customRender: 'action' },
        },
      ];
    },
    rules() {
      return {};
    },
  },
  methods: {
  	async getResourceList() {
  		const { data } = await getResource();
  		this.resource = data;
	  },
    async getList() {
      this.loading = true;
      const { data } = await getRole(this.search);
      this.list = data;
      this.loading = false;
    },
    async create() {
	    this.submiting = true;
      const { data } = await createRole(this.form);
      if (data) {
        this.$message.success('提交成功');
      }
      this.submiting = false;
    },
    async update() {
      this.submiting = true;
      const { data } = await updateRole(this.id, this.form);
      if (data) {
        this.$message.success('提交成功');
      }
      this.submiting = false;
    },
    handleAdd() {
      this.editType = 'add';
      this.getResourceList();
      this.visible = true;
    },
    modify(data) {
      this.editType = 'edit';
      this.form = {
      	...data,
	      permissions: data.permissions.map((item) => item._id),
      };
      this.id = data._id;
	    this.getResourceList();
      this.visible = true;
    },
    async handleOk() {
      if (this.editType === 'add') {
        await this.create();
      } else {
        await this.update();
      }
      this.visible = false;
      this.getList();
    },
    handleCancel() {
      this.form = {};
      this.visible = false;
    },
	  perSearch() {

	  },
	  modifyPermission(id, permissions) {
      this.$refs.permission.show(id, permissions);
	  },
  },
};
</script>

<style lang="less" rel="stylesheet/less">
	.role {

	}
</style>
